import styled from 'styled-components';

export const Table = styled.table.withConfig({ displayName: '-Table' })`
	width: 100%;
  border-spacing: 0px;
  border: 0px;
  position: relative;

	&, * {
		box-sizing: border-box;
	}

	tr > * {
		&:first-child {
			padding-left: 14px;
			padding-right: 14px;
		}

		&:last-child {
			padding-left: 14px;
			padding-right: 14px;
		}
	}

	& > thead > tr > th {
		background-color: #f4f4f4;
		font-size: 11px;
		position: sticky;
		z-index: 100;
		top: 0;
		text-align: left;
		padding-top: 8px;

		// &:first-child {
		// 	padding-left: 16px;
		// }
	}

	& > thead > tr:first-child > th {
		padding-top: 14px;
	}

	& > thead > tr:last-child > th {
		padding-bottom: 14px;
		border-bottom: 1px solid #c4c4c4;
	}

	& > thead > tr.title > th {
		padding-top: 14px!important;
		text-align: center;
	}

	& > tbody > tr > td {
		position: relative;
		font-size: 13px;
		cursor: pointer;
		white-space: nowrap;
		border-bottom: 1px solid #c4c4c4;
		text-align: left;
		height: 73px;

		&:first-child {
			padding-left: 16px;
		}
	}

	& tr.header-like > td {
		background-color: #f4f4f4;
	}

	& tr.special > td {
		background-color: #ffd400;
		height: initial;
		font-weight: bold;
		text-align: center;
		padding-top: 8px;
		padding-bottom: 8px;
	}
`;
